"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";

export function LegalFooter({ locale }: { locale: string }) {
  const t = useTranslations("Legal.footer");

  return (
    <footer className="mt-auto py-6 text-center text-sm text-muted-foreground border-t">
      <div className="flex justify-center gap-4 mb-2">
        <Link
          href={`/${locale}/privacy-policy`}
          className="hover:text-primary transition-colors"
        >
          {t("privacyPolicy")}
        </Link>
        <span>·</span>
        <Link
          href={`/${locale}/terms-and-conditions`}
          className="hover:text-primary transition-colors"
        >
          {t("termsAndConditions")}
        </Link>
        <span>·</span>
        <Link
          href={`/${locale}/support`}
          className="hover:text-primary transition-colors"
        >
          {t("support")}
        </Link>
      </div>
      <p>{t("copyright")}</p>
    </footer>
  );
}
